// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"7390b4eb","433":"f275afe3","453":"53b748f9","465":"04e9a790","488":"dd3d4c6a","570":"9de637e5","587":"e23cd503","626":"ea8d77cc","671":"2d65c373","767":"01caf22a","865":"302eba5d","874":"b87f4455","951":"97410204"}[chunkId] + ".chunk.js";
};